module.exports = "mutation ($id: ID!, $message: String) {\n  ContractDecline(id: $id, message: $message) {\n    id\n  }\n}\n"